import { render, staticRenderFns } from "./alertStep.vue?vue&type=template&id=37575c88&scoped=true"
import script from "./alertStep.vue?vue&type=script&lang=js"
export * from "./alertStep.vue?vue&type=script&lang=js"
import style0 from "./alertStep.vue?vue&type=style&index=0&id=37575c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37575c88",
  null
  
)

export default component.exports